<form [formGroup]="form" class="flex flex-col gap-6">
  <div formGroupName="initialSend" class="flex flex-col gap-4">
    <div>
      <h3 class="text-base font-semibold">Initial Send</h3>
      <p class="text-sm text-slate-500">
        Sent when a referral email is first dispatched to the recipient.
      </p>
    </div>
    <mat-form-field class="w-full">
      <mat-label>Email Subject</mat-label>
      <input
        matInput
        formControlName="subject"
        [placeholder]="initialSendSubjectPlaceholder"
      />
      <mat-hint>{{ subjectVariablesHint }}</mat-hint>
    </mat-form-field>
    <mat-form-field class="w-full">
      <mat-label>Email Template</mat-label>
      <mat-select
        formControlName="templateRef"
        [compareWith]="compareTemplateRef"
      >
        <mat-option [value]="undefined">None</mat-option>
        @for (
          template of referralTemplates$ | async;
          track template.ref.path
        ) {
          <mat-option [value]="template.ref">
            {{ template.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <a
      routerLink="../document-templates"
      class="-mt-3 flex items-center gap-1 self-start text-xs text-primary"
    >
      <mat-icon class="icon-sm">add</mat-icon> Create new template
    </a>
  </div>

  <div formGroupName="updateNotification" class="flex flex-col gap-4">
    <div>
      <h3 class="text-base font-semibold">Update Notification</h3>
      <p class="text-sm text-slate-500">
        Sent when an existing referral is updated.
      </p>
    </div>
    <mat-form-field class="w-full">
      <mat-label>Email Subject</mat-label>
      <input
        matInput
        formControlName="subject"
        [placeholder]="updateNotificationSubjectPlaceholder"
      />
      <mat-hint>{{ subjectVariablesHint }}</mat-hint>
    </mat-form-field>
    <mat-form-field class="w-full">
      <mat-label>Email Template</mat-label>
      <mat-select
        formControlName="templateRef"
        [compareWith]="compareTemplateRef"
      >
        <mat-option [value]="undefined">None</mat-option>
        @for (
          template of referralTemplates$ | async;
          track template.ref.path
        ) {
          <mat-option [value]="template.ref">
            {{ template.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <a
      routerLink="../document-templates"
      class="-mt-3 flex items-center gap-1 self-start text-xs text-primary"
    >
      <mat-icon class="icon-sm">add</mat-icon> Create new template
    </a>
  </div>

  <div formGroupName="patientLetter" class="flex flex-col gap-4">
    <div>
      <h3 class="text-base font-semibold">Patient Letter</h3>
      <p class="text-sm text-slate-500">
        Sent to the patient as a copy of their referral letter.
      </p>
    </div>
    <mat-form-field class="w-full">
      <mat-label>Email Subject</mat-label>
      <input
        matInput
        formControlName="subject"
        [placeholder]="patientLetterSubjectPlaceholder"
      />
      <mat-hint>{{ subjectVariablesHint }}</mat-hint>
    </mat-form-field>
    <mat-form-field class="w-full">
      <mat-label>Email Template</mat-label>
      <mat-select
        formControlName="templateRef"
        [compareWith]="compareTemplateRef"
      >
        <mat-option [value]="undefined">None</mat-option>
        @for (
          template of referralTemplates$ | async;
          track template.ref.path
        ) {
          <mat-option [value]="template.ref">
            {{ template.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <a
      routerLink="../document-templates"
      class="-mt-3 flex items-center gap-1 self-start text-xs text-primary"
    >
      <mat-icon class="icon-sm">add</mat-icon> Create new template
    </a>
  </div>
</form>
